webpackJsonp([205370686332884],{

/***/ 318:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortfolioItem = function (_Component) {
	  _inherits(PortfolioItem, _Component);
	
	  function PortfolioItem(props) {
	    _classCallCheck(this, PortfolioItem);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggleClass = _this.toggleClass.bind(_this);
	    _this.loadIframe = _this.loadIframe.bind(_this);
	    _this.state = {
	      sectionActive: false
	    };
	    return _this;
	  }
	
	  PortfolioItem.prototype.componentDidMount = function componentDidMount() {
	    // console.log('props did mount', this.props);
	    this.loadIframe();
	  };
	
	  PortfolioItem.prototype.loadIframe = function loadIframe() {
	    document.getElementById('myIframe').src = this.props.url;
	  };
	
	  PortfolioItem.prototype.toggleClass = function toggleClass(event) {
	    var currentState = this.state.sectionActive;
	    this.setState({ sectionActive: !currentState });
	    event.preventDefault();
	  };
	
	  PortfolioItem.prototype.render = function render() {
	    //console.log('props', this.props);
	    return _react2.default.createElement(
	      'section',
	      { className: 'portfolio-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              this.props.title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-21' },
	            _react2.default.createElement('iframe', { src: '#', title: this.props.title, id: 'myIframe' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 text-center' },
	            _react2.default.createElement(
	              'div',
	              { onClick: this.toggleClass, className: this.state.sectionActive ? 'description active' : 'description' },
	              _react2.default.createElement('i', { className: 'fas fa-info' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'lead' },
	                this.props.description
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PortfolioItem;
	}(_react.Component);
	
	exports.default = PortfolioItem;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global graphql */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _porfolioItem = __webpack_require__(203);
	
	var _porfolioItem2 = _interopRequireDefault(_porfolioItem);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioItem = function PortfolioItem(props) {
	  var decodeURLParams = function decodeURLParams(search) {
	    var hashes = search.slice(search.indexOf('?') + 1).split('&');
	    return hashes.reduce(function (params, hash) {
	      var _extends3;
	
	      var split = hash.indexOf('=');
	
	      if (split < 0) {
	        var _extends2;
	
	        return _extends(params, (_extends2 = {}, _extends2[hash] = null, _extends2));
	      }
	
	      var key = hash.slice(0, split);
	      var val = hash.slice(split + 1);
	
	      return _extends(params, (_extends3 = {}, _extends3[key] = decodeURIComponent(val), _extends3));
	    }, {});
	  };
	
	  var displayData = decodeURLParams(props.location.search);
	  return _react2.default.createElement(
	    'main',
	    { id: 'main-content' },
	    _react2.default.createElement(_porfolioItem2.default, { title: displayData.title, description: displayData.description, url: displayData.url })
	  );
	};
	
	exports.default = PortfolioItem;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-item-js-257810c0034616e3198b.js